// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const edb: CountryValidator<"MK"> = createValidator(
  "mk.edb",
  125,
);

export default edb;
export const compact = edb.compact;
export const format = edb.format;
export const validate = edb.validate;
export const generate = (): string =>
  edb.generate?.() ??
  (() => {
    throw new Error(
      "Validator mk.edb cannot generate values",
    );
  })();
